export const messages = {
  en: {
    sellingCostManage: {
      queryConditions: 'Query Conditions',
      sellingCostTable: 'Selling Cost Table',
      date: 'Date',
      salesRevenue: 'Sales Revenue',
      salesCost: 'Sales Cost',
      grossMargin: 'Gross Margin',
      lossMoney: 'Loss Amount',
      createTime: 'Create Time',
      startTime: 'Start Time',
      endTime: 'End Time',
      search: 'Search',
      reset: 'Reset'
    }
  },
  zh: {
    sellingCostManage: {
      queryConditions: '查询条件',
      sellingCostTable: '销售成本表',
      date: '日期',
      salesRevenue: '销售收入',
      salesCost: '销售成本',
      grossMargin: '销售毛利',
      lossMoney: '亏损金额',
      createTime: '创建时间',
      startTime: '开始时间',
      endTime: '结束时间',
      search: '查询',
      reset: '重置'
    }
  }
}